import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { AttendanceDailyPlaceTableFilterSchema } from "../-zod-schema";

export const Route = createFileRoute(
  "/_staff/time-and-attendance/_layout/_list/summary/daily-place/",
)({
  validateSearch: zodValidator(AttendanceDailyPlaceTableFilterSchema),
});
